<script setup lang="ts">
import AppFooterColumn from "@/layout/AppFooterColumn.vue";
import AppFooterLinks from "@/layout/AppFooterLinks.vue";
import AppFooter from "@/layout/AppFooter.vue";
import AppHeader from "@/layout/AppHeader.vue";
import { useMenuStore } from "@/stores/menu.ts";

const menuStore = useMenuStore();
</script>

<template>
  <app-header />

  <slot />

  <AppFooter :company="$whitelabel.company" :inverted="true">
    <AppFooterColumn>
      <AppFooterLinks :links="menuStore.footer" />
    </AppFooterColumn>
  </AppFooter>
</template>
